module.exports = __webpack_public_path__ + "media/images/brands/marque-l-oreal-73a878a86bb6b2e51d622eef1f1b19e2.jpg";